import styled from 'styled-components'
import { giphyCharcoal, giphyDarkCharcoal, giphyLightGrey, giphyLightestGrey } from '@giphy/colors'
import { Pill, TextInput, IconButton } from 'ui'
import { useContext, useState } from 'react'
import { CopilotContext } from '../context'
import { CopilotApiContext } from '../contexts/api'
import { CopilotPresetTag } from 'shared/types/copilot'
import { CreationToolUploadContext } from '../../manager'

const Container = styled.div`
    margin-top: 4px;
`

const Tags = styled.div`
    margin-top: 15px;
`

const Tag = styled(Pill)`
    margin: 0 6px 6px 0;
    padding-left: 16px;
    &:active {
        opacity: 0.8;
    }
`

const Bin = styled.div`
    display: flex;
    margin-top: 10px;
    p {
        font-size: 14px;
    }
`
const StyledIconButton = styled(IconButton)`
    pointer-events: none;
`

function CopilotTagManager({ sourceId }: { sourceId?: string }) {
    const { updatePreset } = useContext(CopilotApiContext)
    const { getActivePreset } = useContext(CopilotContext)
    const { addTags } = useContext(CreationToolUploadContext)
    const [value, setValue] = useState<string>('')
    const preset = getActivePreset()
    const tags = preset?.upload_optional_tags.tags || []

    const onInput = () => {
        const newTags = value.split(',').map((name) => ({
            name: name.trim(),
            is_featured: false,
        }))
        if (preset) {
            updatePreset({
                ...preset,
                upload_optional_tags: {
                    tags: [...tags, ...newTags],
                },
            })
            setValue('')
        }
    }

    const onRemove = (tag: CopilotPresetTag) => {
        if (preset) {
            updatePreset({
                ...preset,
                upload_optional_tags: {
                    tags: tags.filter((t) => t.name !== tag.name),
                },
            })
        }
    }

    const onApply = (tag: CopilotPresetTag) => {
        const newTags = [tag].map((t) => ({
            text: t.name,
            isFeatured: t.is_featured,
        }))
        addTags(newTags, sourceId)
    }

    return (
        <Container>
            <TextInput
                placeholder={'Add to Tag Manager'}
                size="medium"
                color={giphyDarkCharcoal}
                value={value}
                onChange={setValue}
                onEnterKeyPress={() => onInput()}
            >
                <StyledIconButton
                    gradient="purple-indigo"
                    icon="add"
                    iconColor={'#FFF'}
                    size="medium"
                    onClick={() => onInput()}
                />
            </TextInput>
            <Tags>
                {tags &&
                    tags.map((tag) => (
                        <Tag
                            key={tag.name}
                            round
                            removeable
                            size="medium"
                            color={giphyCharcoal}
                            textColor={giphyLightestGrey}
                            onRemove={() => onRemove(tag)}
                            onClick={() => onApply(tag)}
                        >
                            #{tag.name}
                        </Tag>
                    ))}
            </Tags>
            <Bin>
                <StyledIconButton color={giphyLightGrey} icon="info" inverted />
                <p>Tags added here are added as suggestions at the individual GIF level</p>
            </Bin>
        </Container>
    )
}

export default CopilotTagManager
